import IdBadgeController from './vd-id-badge.controller'
import template from './vd-id-badge.html'

const IdBadgeComponent = {
  bindings: {
    ngClick: '&?',
    image: '<?',
    hyperlink: '@?',
    lazyLoad: '<?',
  },
  transclude: {
    header: '?header',
    description: '?description',
    avatar: '?avatar',
    status: '?status',
  },
  controller: IdBadgeController,
  template,
}

export default IdBadgeComponent
